import { useQuery } from '@tanstack/react-query'
import { eventsApi, EventAccessCheckResponse } from '../api/events'

export const useEventAccess = (eventSlug: string) => {
  return useQuery<EventAccessCheckResponse>({
    queryKey: ['eventAccess', eventSlug],
    queryFn: () => eventsApi.checkEventAccess(eventSlug),
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: false, // Don't retry 403 errors
  })
}